/* eslint-disable object-shorthand */
const colors = {
  primary:    '#37bad5',
  secondary:  'black',
  tertiary:   'white',
  level1:     '#ffbc00',
  level2:     '#8f288c',
  level3:     '#26a7df',
  level4:     '#e80a89',
  level5:     '#f59122',
  level6:     '#37b34a',
  gameshow:   '#742CBF',
  question:   '#45B3EC',
  answer:     '#6FC36E'
};

const fonts = {
  primary: 'BrandonTextWeb',
  secondary: 'Orbitron',
  tertiary: 'Ubuntu'
};

module.exports = {
  colors: colors,
  fonts: fonts,
  global: {
    body: {
      background: 'transparent',
      fontFamily: fonts.primary,
      fontWeight: 'normal',
      fontSize: '2em',
      color: colors.primary,
      overflow: 'hidden'
    },
    'html, body': {
      // height: '100%'
    },
    '*': {
      boxSizing: 'border-box'
    },
    input: {
      color: 'black',
      fontWeight: 'bold',
      backgroundColor: 'white',
      fontSize: '2.66em',
      fontFamily: fonts.primary,
      padding: '0.25em 0.25em 0.2em',
      margin: '1% 1% 3%',
      width: '98%'
    },
    label: {
      color: 'white',
      fontWeight: 'bold',
      fontSize: '1.8em',
      margin: '0.1em 0 0'
    }
  },
  progress: {
    bar: {
      container: {
        position: 'absolute',
        height: '22px',
        width: '100%',
        bottom: 0,
        left: 0,
        transition: 'all 1s ease-in-out 0.2s',
        zIndex: 1000
      },
      bar: {
        height: '100%',
        background: colors.primary,
        transition: 'all 0.3s ease-out',
        fontSize: '12px',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        padding: '4px',
        textAlign: 'right'
      }
    },
    number: {
      container: {
        position: 'absolute',
        bottom: 10,
        right: 10,
        zIndex: 1000,
        color: colors.tertiary
      }
    }
  },
  components: {
    codePane: {
      pre: {
        margin: 'auto',
        fontSize: '1em',
        fontWeight: 'normal',
        fontFamily: fonts.tertiary,
        minWidth: '100%',
        maxWidth: 800
      },
      code: {
        textAlign: 'left',
        padding: 20,
        fontWeight: 'normal'
      }
    },
    code: {
      color: 'black',
      fontSize: '2.66em',
      fontFamily: fonts.tertiary,
      margin: '0.25em auto',
      backgroundColor: 'rgba(0,0,0,0.15)',
      padding: '0 10px',
      borderRadius: 3
    },
    heading: {
    },
    link: {
      textDecoration: 'none'
    },
    listItem: {
      fontSize: '2.66em',
      padding: '0 0 0.5em'
    },
    list: {
      textAlign: 'center',
      listStyle: 'none',
      padding: '0.5em 0'
    },
    s: {
      strikethrough: {}
    },
    text: {
      color: 'black',
      fontSize: '2.66em',
      fontFamily: fonts.primary,
      margin: '0.25em auto',
      textShadow: '0 0 10px rgba(0,0,0,0.2)'
    }
  }
};



// WEBPACK FOOTER //
// ./programs/epsHybridIntermediates/theme.js